/* tslint:disable */

/**
 */
export class MembershipTransaction {
    amount_transaction?: number;
    type_transaction?: string;
    date_transaction?: string;
}
